import { Suspense } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FooterCategory from "../FooterCategory";
// import moment from "moment-hijri";
import jalaali from "jalaali-js";

const Footer = () => {
  const { t } = useTranslation();

  const { jy } = jalaali.toJalaali(new Date());

  return (
    <footer
      className="relative bg-[#334780] text-white"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        {t("footer.footer")}
      </h2>
      <div className="px-6 pt-16 pb-8 mx-auto max-w-7xl sm:pt-24 lg:px-8 lg:pt-10">
        <div className="xl:grid xl:grid-cols-3 xl:gap-16 mt-16">
          <div className="space-y-10">
            <div className="space-y-6">
              <div className="max-w-[155px] sm:max-w-[140px]">
                <img
                  src="/Final Logo white-02.png"
                  alt="Ministry of Higher Education (HELP)"
                  className="w-full h-auto object-contain rounded-md"
                  decoding="async"
                  loading="lazy"
                />
              </div>
              <p className="text-sm leading-6 text-gray-300">
                {t("footer.help_description")}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 mt-16 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6">
                  {t("quick-links")}
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <Link
                      to="/"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      {t("home")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/courses"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      {t("courses")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/certificates/verify"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      {t("certificates")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      {t("about-us")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      {t("contact-us")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6">
                  {t("categories")}
                </h3>
                <Suspense fallback="loading">
                  <FooterCategory />
                </Suspense>
              </div>
            </div>
            <div className="md:grid md:grid-cols-1 md:gap-8">
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6">
                  {t("footer.mohe")}
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <Link
                      to="https://www.mohe.gov.af/"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      د لوړو زده کړو وزارت
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="https://journals.edu.gov.af/"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      افغانستان علمی او څیړنیز ژورنالونه
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="https://hemis.edu.af/"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      HEMIS
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between pt-8 pb-6 mt-12 border-t sm:flex-row gap-y-4 border-white/10 sm:mt-16 lg:mt-20">
          <div>
            <p className="text-sm leading-5 text-gray-400">
              <>{jy}</>
              &copy; {t("footer.right")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
